var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCalendarClock = function SvgCalendarClock(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 30",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "calendar_clock_svg__a",
    width: 30,
    height: 30,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h30v30H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#calendar_clock_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.635 26.875a2.18 2.18 0 0 1-1.604-.656 2.18 2.18 0 0 1-.656-1.604V7.885q0-.947.656-1.604a2.18 2.18 0 0 1 1.604-.656h1.73V3.942q0-.408.277-.685a.93.93 0 0 1 .687-.276q.409 0 .684.276a.93.93 0 0 1 .275.685v1.683h9.472V3.918q0-.398.27-.668.269-.27.668-.269.398 0 .667.27.27.27.27.667v1.707h1.73q.948 0 1.604.656.656.657.656 1.604v5.892q0 .398-.27.667a.9.9 0 0 1-.668.27.9.9 0 0 1-.668-.27.9.9 0 0 1-.269-.667v-.892H6.25v11.73q0 .145.12.265t.265.12h7.646q.4 0 .668.27.27.27.27.668 0 .399-.27.668a.9.9 0 0 1-.668.269zm16.105 1.25q-2.34 0-3.983-1.642-1.642-1.641-1.642-3.983t1.642-3.983q1.642-1.642 3.983-1.642t3.983 1.642 1.642 3.983-1.642 3.983-3.983 1.642m.553-5.853v-2.897a.53.53 0 0 0-.165-.387.53.53 0 0 0-.775 0 .53.53 0 0 0-.166.387v2.88q0 .22.082.428.082.206.258.382l1.906 1.906a.55.55 0 0 0 .383.17.53.53 0 0 0 .396-.17.54.54 0 0 0 .175-.39.54.54 0 0 0-.175-.389z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarClock);
export default ForwardRef;